import type { TFunction } from "i18next";


interface ElectionCountdownHeaderProps {
  electionEndAt: string;
  currentTime: Date;
  t: TFunction;
}

/** Segmented digital timer: "Ends in" + d/h/min/s segments. */
function ElectionCountdownHeader({
  electionEndAt,
  currentTime,
  t,
}: ElectionCountdownHeaderProps) {
  const endDate = new Date(electionEndAt);
  const now = currentTime;
  const remainingSeconds = Math.max(0, Math.floor((endDate.getTime() - now.getTime()) / 1000));

  const days = Math.floor(remainingSeconds / 86400);
  const hours = Math.floor((remainingSeconds % 86400) / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  const segments = [
    ...(days > 0 ? [{ value: days, label: t("d") }] : []),
    { value: hours, label: t("h") },
    { value: minutes, label: t("min") },
    { value: seconds, label: t("s") },
  ];

  return (
    <div className="mb-md flex shrink-0 items-center gap-sm rounded-[14px] border border-solid border-white-alpha-8 bg-white-alpha-6 px-lg py-md">
      <span className="mr-xs whitespace-nowrap [font-family:Lato,sans-serif] text-[11px] text-white-alpha-45">
        ⏱ {t("Ends in")}
      </span>
      <div className="ml-auto flex gap-xs">
        {segments.map((seg, i) => (
          <div key={i} className="flex min-w-[32px] flex-col items-center">
            <div className="[font-family:'Rubik_One',sans-serif] text-[16px] leading-[1.1] text-white">
              {String(seg.value).padStart(2, "0")}
            </div>
            <div className="[font-family:Lato,sans-serif] text-[9px] tracking-[0.5px] text-white-alpha-40 uppercase">
              {seg.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ElectionCountdownHeader;
